module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 665
// module chunks = 1